<template>
  <v-card class="card-height" rounded="lg" height="100%">
    <!-- 헤더 -->
    <card-header
      :title="title"
      :icon="icon"
      :color="headerColor"
      variant="gradient"
    />

    <!-- 콘텐츠 리스트 -->
    <v-card-text v-if="contents && contents.length">
      <a
        v-for="(content, index) in contents"
        :key="index"
        :href="`${urlPrefix}/${content.idx}`"
        target="_blank"
      >
        <div class="d-flex text-left ma-2 justify-space-between">
          <p class="accent--text text-left ma-0">
            <span class="red--text font-weight-bold">{{ prefix }}</span>
            {{ content.title }}
          </p>

          <p class="content-date">
            {{ content.date || content.created_at }}
          </p>
        </div>
      </a>
    </v-card-text>

    <!-- 빈 데이터 처리 -->
    <v-card-text v-else class="empty-content">
      {{ emptyText }}
    </v-card-text>
  </v-card>
</template>

<script>
import CardHeader from "@/components/cards/CardHeader.vue";

export default {
  components: { CardHeader },
  props: {
    headerColor: { type: String, default: "" },
    contents: { type: Array, default: () => [] },
    prefix: { type: String, default: "" },
    icon: { type: String, default: "" },
    title: { type: String, default: "" },
    urlPrefix: { type: String, default: "" },
  },
  data() {
    return {
      emptyText: "현재 표시할 내용이 없습니다.",
    };
  },
};
</script>

<style scoped>
/* 카드 크기 */
.card-height {
  min-height: 250px;
  max-height: 500px;
}

/* 날짜 스타일 */
.content-date {
  text-align: right;
  color: #757575;
  font-size: 14px;
  margin: 0;
}

/* 빈 콘텐츠 메시지 스타일 */
.empty-content {
  text-align: center;
  font-size: 16px;
  color: #9e9e9e;
  padding: 20px 0;
}
</style>
